import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Image, ArrowRight, Search } from 'lucide-react';

const PWAGalleries = () => {
  const [recentGalleries, setRecentGalleries] = useState([]);

  useEffect(() => {
    const recent = JSON.parse(localStorage.getItem('recentGalleries') || '[]');
    setRecentGalleries(recent);
  }, []);

  const formatDate = (timestamp) => {
    return new Date(timestamp).toLocaleDateString('en-CA', {
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <div className="px-4 pt-6 space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-heading text-stone-800">My Galleries</h1>
        <p className="text-stone-500 text-sm mt-1">Your recently viewed photo galleries</p>
      </div>

      {/* Search Link */}
      <Link to="/app">
        <Card className="border-stone-200 border-dashed hover:border-amber-300 transition-colors">
          <CardContent className="p-4 flex items-center gap-4">
            <div className="bg-amber-50 p-3 rounded-lg">
              <Search className="h-5 w-5 text-amber-600" />
            </div>
            <div className="flex-1">
              <p className="font-medium text-stone-800">Enter Access Code</p>
              <p className="text-sm text-stone-500">View a new gallery</p>
            </div>
            <ArrowRight className="h-5 w-5 text-stone-400" />
          </CardContent>
        </Card>
      </Link>

      {/* Recent Galleries */}
      {recentGalleries.length > 0 ? (
        <div className="space-y-3">
          <h2 className="text-sm font-medium text-stone-600">Recently Viewed</h2>
          {recentGalleries.map((gallery) => (
            <Link
              key={gallery.code}
              to={`/app/gallery/${gallery.code}`}
            >
              <Card className="border-stone-200 hover:border-amber-300 transition-colors mb-2">
                <CardContent className="p-4 flex items-center gap-4">
                  <div className="bg-stone-100 p-3 rounded-lg">
                    <Image className="h-6 w-6 text-stone-500" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-medium text-stone-800 truncate">
                      {gallery.name}
                    </p>
                    <div className="flex items-center gap-2 text-sm text-stone-500">
                      <span className="font-mono">{gallery.code}</span>
                      <span>•</span>
                      <span>{formatDate(gallery.timestamp)}</span>
                    </div>
                  </div>
                  <ArrowRight className="h-5 w-5 text-stone-400 shrink-0" />
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      ) : (
        <div className="text-center py-12">
          <div className="bg-stone-100 p-4 rounded-full w-fit mx-auto mb-4">
            <Image className="h-10 w-10 text-stone-400" />
          </div>
          <h2 className="text-lg font-medium text-stone-800">No galleries yet</h2>
          <p className="text-sm text-stone-500 mt-1">
            Enter an access code to view your first gallery
          </p>
          <Link to="/app">
            <Button className="mt-4 btn-action">
              Enter Access Code
            </Button>
          </Link>
        </div>
      )}
    </div>
  );
};

export default PWAGalleries;
